<script>
  import DesktopLayout from '../../layout/DesktopLayout.svelte';

  export let option = {};
</script>

<DesktopLayout {option}>
  <svelte:fragment slot="header"><slot name="header" /></svelte:fragment>
  <svelte:fragment slot="left"><slot name="left" /></svelte:fragment>
  <svelte:fragment slot="head"><slot name="head" /></svelte:fragment>
  <svelte:fragment slot="content"><slot name="content" /></svelte:fragment>
  <svelte:fragment slot="comment"><slot name="comment" /></svelte:fragment>
  <svelte:fragment slot="right"><slot name="right" /></svelte:fragment>
  <svelte:fragment slot="footer"><slot name="footer" /></svelte:fragment>
</DesktopLayout>
